import { Box, Flex, Text } from "@chakra-ui/react";
import { ImageFragment } from "@ui/post";
import Image from "next/image";

export interface ITeamCardProps {
  image?: {
    url?: string;
    handle?: string;
    height: number;
    width: number;
    blurDataURL: string;
    alt?: string;
  };
  photoPlaceholder?: ImageFragment;
  blurb?: string;
  name: string;
  hasBio?: boolean;
  bio?: any;
  role: string;
}

export interface TeamCardProps extends ITeamCardProps {
  onOpen?: (props: ITeamCardProps) => void;
}

export const TeamCard = (props: TeamCardProps) => {
  const { name, role, image } = props;
  return (
    <Flex
      direction="column"
      align="center"
      textAlign="center"
      onClick={() =>
        props?.hasBio && props?.onOpen ? props.onOpen(props) : null
      }
      transition="all 0.2s"
      _hover={{
        transform: props?.hasBio ? "scale(1.05)" : "",
      }}
      cursor="pointer"
    >
      <Box w="40" h="40" rounded="full" position="relative" overflow="hidden">
        <Image
          {...image}
          src={image?.url as string}
          alt={image?.alt ?? `${name}'s headshot`}
          width={160}
          height={160}
          style={{ objectFit: "cover", height: "auto", width: "100%" }}
          loading="lazy"
          placeholder={
            typeof image?.blurDataURL === "string" ? "blur" : undefined
          }
          blurDataURL={
            typeof image?.blurDataURL === "string"
              ? image?.blurDataURL
              : undefined
          }
        />
      </Box>

      <Box mt="4">
        <Text fontWeight="bold" fontSize="lg">
          {name}
        </Text>
        {role && (
          <Text as="i" fontWeight="semibold" color="blue.500">
            {role}
          </Text>
        )}
      </Box>
    </Flex>
  );
};
